import { render, staticRenderFns } from "./MainUserCenter.vue?vue&type=template&id=55944654&"
import script from "./MainUserCenter.vue?vue&type=script&lang=js&"
export * from "./MainUserCenter.vue?vue&type=script&lang=js&"
import style0 from "./MainUserCenter.vue?vue&type=style&index=0&id=55944654&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports